import React from 'react';
import { Typography } from 'antd';
import styled, { css } from 'styled-components';

const Title = styled(Typography.Title)`
  color: var(--Text-text-600, #232b3a);
  font-family: Roboto;
  ${(p) => {
    if (p.level === 3) {
      return css`
        &.ant-typography {
          margin: 0;
          /* Header/H3 - Medium */
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          letter-spacing: 0.24px;
        }
      `;
    }
    if (p.level === 4) {
      return css`
        &.ant-typography {
          margin: 0;
          /* Header/H4 - Medium */
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px; /* 114.286% */
          letter-spacing: 0.42px;
        }
      `;
    }
  }}
`;

const Caption = styled(Typography.Text)`
  color: var(--Text-text-300, #8991a0);

  /* Body/Caption 1 - Regular */
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 120% */
  letter-spacing: 0.1px;
`;

const ATypography = {
  Title,
  Caption,
};

export default ATypography;
